<template>
    <form @submit.prevent>
        <div class="container mt-4">
            <div v-if="selectedPrimaryLocation" class="mt-3">
                <h5>Selected Primary Location</h5>
            </div>
            <div class="row mb-3">
                <div class="col">
                    <label for="searchType" class="form-label">Search By</label>
                    <select id="searchType" class="form-select" v-model="searchType">
                        <option value="DME_ID">Search DME_ID</option>
                        <option value="name">Search Location</option>
                    </select>
                </div>
                <div class="col">
                    <label for="searchQuery" class="form-label">Query</label>
                    <input id="searchQuery" class="form-control" v-model="searchQuery"
                           placeholder="Enter search query"/>
                </div>
                <div class="col d-flex align-items-end">
                    <button class="btn btn-primary" @click="searchLocations">Search</button>
                </div>
            </div>
            <div v-if="searchResults.length > 0" class="mb-3">
                <h5>Search Results</h5>
                <ul class="list-group">
                    <li v-for="result in searchResults" :key="result.id" class="list-group-item">
                        <div class="d-flex justify-content-between">
                            <div>
                                <div><strong>DME ID:</strong> {{ result.id }}</div>
                                <div><strong>Name:</strong> {{ result.name }}</div>
                                <div><strong>Address:</strong> {{ result.address1 }}<span
                                    v-if="result.address2">,</span> {{ result.address2 || '' }}
                                </div>
                                <div><strong>City, State ZIP:</strong> {{ result.city }}, {{ result.state }}
                                    {{ result.zip }}
                                </div>
                            </div>
                            <div class="d-flex flex-column align-items-end justify-content-center">
                                <button v-if="!result.is_child && !result.migrated" class="btn btn-secondary"
                                        @click="selectPrimaryLocation(result)">Select as Primary
                                </button>
                                <div v-if="result.is_child" class="alert alert-warning">
                                    The selected location is a child location.
                                </div>
                                <div v-if="result.migrated" class="alert alert-danger">
                                    The location has already been migrated.
                                </div>
                                <div v-if="result.has_api_key" class="p-1 rounded mt-1 alert-danger">
                                    API Key found, please contact Greg if migrating this DME.
                                </div>

                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div v-if="isSearchResultsEmpty" class="mb-3">
                <ul class="list-group">
                    <li class="list-group-item">
                        <div class="d-flex justify-content-center">
                            <div class="alert alert-danger text-center">
                                No Locations were found with that ID.
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </form>
</template>


<script setup>
import {ref, defineProps, defineEmits, onMounted} from 'vue';
import axios from 'axios';

const searchQuery = ref('');
const searchType = ref('DME_ID');
const searchResults = ref([]);
const isSearchResultsEmpty = ref(false);
const selectedPrimaryLocation = ref(null);
const emit = defineEmits(['update-location', 'back']);
const searchLocations = async () => {
    searchResults.value = [];
    try {
        const response = await axios.get('/api/migration-search', {
            params: {
                query: searchQuery.value,
                type: searchType.value
            }
        });
        searchResults.value = JSON.parse(response.data);

        isSearchResultsEmpty.value = searchResults.value.length === 0;

    } catch (error) {
        console.error('Failed to search:', error);
    }
};

// Function to select the primary location
const selectPrimaryLocation = (location) => {
    selectedPrimaryLocation.value = location;

    // Create the new location data
    const newLocationData = {
        dme_id: location.id,
        name: location.name,
        loc_name: location.name,
        address1: location.address1,
        address2: location.address2 || null,
        zip: location.zip,
        city: location.city,
        state: location.state,
        country: location.country,
        phone: location.phone,
    };

    // Update org with the new location data
    emit('update-location', newLocationData);
    emit('back');
};

</script>

